export const BloodTestFields = [
  {
    index: 0,
    label: '血圧（拡張期）',
    unit: 'mmHg',
    code: 'bp_h',
  },{
    index: 1,
    label: '血圧（収縮期）',
    unit: 'mmHg',
    code: 'bp_l',
  },{
    index: 2,
    label: '空腹時血糖',
    unit: 'mg/dl',
    code: 'glu',
  },{
    index: 3,
    label: 'HDL（善玉）コレステロール',
    unit: 'mg/dl',
    code: 'hdl',
  },{
    index: 4,
    label: 'LDL（悪玉）コレステロール',
    unit: 'mg/dl',
    code: 'ldl',
  },{
    index: 5,
    label: '中性脂肪（TG）',
    unit: 'mg/dl',
    code: 'tg',
  },{
    index: 6,
    label: 'HbA1c',
    unit: '%',
    code: 'hba1c',
  },{
    index: 7,
    label: 'クレアチニン',
    unit: 'mg/dl',
    code: 'cre',
  },{
    index: 8,
    label: '尿酸（UA）',
    unit: 'mg/dl',
    code: 'ua',
  }
]